import SvgMyAccount from "@Components/CustomIcon/SvgMyAccount"
import CustomSettingTitle from "@Components/CustomSettingTitle/CustomSettingTitle"
import { baseColors } from "@Constants/baseStyles"
import React, { useEffect, useState } from "react"
import { Image, View } from "react-native"
import { ActivityIndicator, Avatar, Divider, List, Switch } from "react-native-paper"
import styles from "./styles"
import SvgNext from "@Components/CustomIcon/SvgNext"
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil"
import { userAtom } from "@Recoil/Atom/userAtom"
import { navigationAtom } from "@Recoil/navigationAtom"
import { NotificationService } from "@Services/Notifications.Service"
import { UserService } from "@Services/User.service"
import { ShowToast } from "@Components/ToastNotification/ToastNotification"
import { message } from "@Constants/constant"
import { notificationTokenAtom } from "@Recoil/Atom/notificationTokenAtom"
import CustomScrollableModal from "@Components/Modal/CustomScrollableModal/CustomScrollableModal"
import { OpenSansText } from "@Components/CustomText/OpenSansText"
import { LocalStorage } from "@Services/sharedPreferences/localStorage"
import { useIsFocused } from "@react-navigation/native"
import { useNotifications } from "../../../Hooks/useNotifications"
import { Spacer } from "../../../Components/Space"

const avatarIcon = require("@assets/icons/profile.png")

import { messaging, getToken, onMessage } from "@Services/FirebaseConfig";

export async function registerForPushNotificationsAsync() {
  if (Platform.OS === "web") {
    const permission = await Notification.requestPermission();
    console.log('=============== permission =====================');
    console.log(permission);
    console.log('====================================');
    if (permission === "granted") {
      const token = await getToken(messaging);
      
      console.log('=============== Web Token =====================');
      console.log(token);
      console.log('====================================');
      return token;
    }
  } else {
    const { status } = await Notifications.requestPermissionsAsync();
    if (status === "granted") {
      const token = (await Notifications.getExpoPushTokenAsync()).data;
      console.log("Mobile Token:", token);
      return token;
    }
  }
}

const MyAccount = ({ navigation }) => {
    const user = useRecoilValue(userAtom)
    const isFocused = useIsFocused()
    const [isSwitchOn, setIsSwitchOn] = useState(false)
    const setNavigationState = useSetRecoilState(navigationAtom)
    const onToggleSwitch = () => setIsSwitchOn(!isSwitchOn)
    const [pushToken, setPushToken] = useRecoilState(notificationTokenAtom)
    const [updateToken, setUpdateToken] = useState(false)
    const [errorModalVisible, setErrorModalVisible] = useState(false)
    const [fetchingProfileImg, setFetchingProfileImg] = useState(true)
    const [userProfileImg, setUserProfileImg] = useState("")
    const [errorMessage, setErrorMessage] = useState("")

    const { notificationStatus } = useNotifications()

    const fetchUserAvar = () => {
        setFetchingProfileImg(true)
        UserService.getProfilePicture(user?.id)
            .then((response) => {
                const profile = response?.data?.data
                setUserProfileImg(profile?.[0]?.imageurl)
                setFetchingProfileImg(false)
            })
            .catch(() => setFetchingProfileImg(false))
    }

    const avatar = () => (
        <Image source={userProfileImg ? { uri: userProfileImg } : avatarIcon} style={styles.avatar} size={50} />
    )
    const rightIcon = () => <List.Icon style={{ paddingLeft: 40 }} icon={() => <SvgNext />} />
    const [registring, setRegistring] = useState(false)
    const switchContent = () =>
        registring ? (
            <ActivityIndicator color={baseColors.green.primary} />
        ) : (
            <Switch
                disabled={updateToken}
                color={baseColors.green.primary}
                value={pushToken ? true : false}
                onValueChange={() => registerNotification()}
            />
        )

    const accountItems = [
        {
            title: `${user?.firstName} ${user?.lastName}` || "Ivehte User Name",
            titleStyle: styles.descriptionStyle,
            leftContent: avatar,
            rigthContent: rightIcon,
            onPress: () => goto("Profile", { userProfileImg })
        },
        {
            title: "Adresse mail",
            titleStyle: styles.titleStyle,
            description: `${user?.email} ` || "contact.alisondanis@gmail.com",
            descriptionStyle: styles.descriptionStyle,
            rigthContent: rightIcon,
            onPress: () => {}
            // onPress: () => goto("EmailAdress")
        },
        {
            title: "Mot de passe",
            titleStyle: styles.titleStyle,
            description: "**********",
            descriptionStyle: styles.descriptionStyle,
            rigthContent: rightIcon,
            onPress: () => goto("Password")
        },
        {
            title: "Notifications",
            titleStyle: styles.titleStyle,
            description: pushToken ? "Activées" : "Désactivées",
            descriptionStyle: styles.descriptionStyle,
            rigthContent: switchContent,
            onPress: () => {
                if (!updateToken) {
                    registerNotification()
                }
            }
        }
    ]

    const fetchToken = async () => {
        setUpdateToken(true)
        setErrorMessage("")
        setErrorModalVisible(false)
        UserService.getNotificationToken()
            .then((response) => {
                const data = response.data?.data
                if (data.length > 0) {
                    if (data.includes(pushToken)) {
                        setPushToken(pushToken)
                    } else {
                        setPushToken(null)
                    }
                } else {
                    setPushToken(null)
                }
                setUpdateToken(false)
            })
            .catch((e) => {
                setUpdateToken(false)
                setErrorMessage(JSON.stringify(e.response))
                setErrorModalVisible(true)
                ShowToast({ type: "error", message: "Error getting notification token" })
            })
    }

    useEffect(() => {
        fetchToken()
    }, [])

    useEffect(() => {
        fetchUserAvar()
    }, [isFocused])

    const registerNotification = () => {
        setErrorModalVisible(false)
        setErrorMessage("")
        if (!pushToken) {
            setRegistring(true)
            NotificationService.registerForPushNotificationsAsync()
                .then((token) => {
                    console.log();
                    UserService.subscribeNotification(token)
                        .then((response) => {
                            setPushToken(token)
                            ShowToast({ type: "success", message: "Système de notification activé avec succès" })
                            LocalStorage.saveNotificationStatus(true)
                        })
                        .catch((e) => {
                            setErrorMessage(JSON.stringify(e))
                            ShowToast({ type: "error", message: "Failed to get push token" })
                            setErrorModalVisible(true)
                            setRegistring(false)
                        })
                    setPushToken(token)
                    setRegistring(false)
                })
                .catch((e) => {
                    setErrorMessage(JSON.stringify(e))
                    ShowToast({ type: "error", message: "Failed to get push token" })
                    setErrorModalVisible(true)
                    setRegistring(false)
                })
        } else {
            setRegistring(true)
            UserService.unsubscribeNotification(pushToken)
                .then((response) => {
                    setPushToken(null)
                    LocalStorage.saveNotificationStatus(false)
                    ShowToast({ type: "success", message: "Système de notification désactivé" })
                    setRegistring(false)
                })
                .catch((e) => {
                    setErrorMessage(JSON.stringify(e.response))
                    setErrorModalVisible(true)
                    ShowToast({ type: "error", message: message.serverError })
                    setRegistring(false)
                })
        }
    }

    const goto = (nextScreen, params = undefined) => {
        setNavigationState(nextScreen)
        navigation.navigate(nextScreen, { ...params })
    }
    const EditMyAccount = () => {
        setNavigationState("MyAccountForm")
        navigation.navigate("MyAccountForm")
    }

    return (
        <View style={styles.container}>
            <CustomScrollableModal open={errorModalVisible} toggleModal={() => setErrorModalVisible(false)}>
                <View>
                    <OpenSansText>{errorMessage}</OpenSansText>
                </View>
            </CustomScrollableModal>

            <CustomSettingTitle
                title="Mon compte"
                subTitle="Vous pouvez éditer vos informations."
                icon={<SvgMyAccount />}
            />

            <Spacer />

            <View style={styles.content}>
                <List.Section>
                    {accountItems.map((item, index) => {
                        const showDivider = index !== accountItems.length - 1
                        return (
                            <View key={index}>
                                <List.Item
                                    style={styles.item}
                                    title={item.title}
                                    titleStyle={item.titleStyle}
                                    description={item.description}
                                    descriptionStyle={item.descriptionStyle}
                                    left={item.leftContent}
                                    right={item.rigthContent}
                                    onPress={item.onPress}
                                />
                                {showDivider && <Divider style={styles.divider} />}
                            </View>
                        )
                    })}
                </List.Section>
            </View>
        </View>
    )
}

export default MyAccount
